/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ProjectDtoModel, ProjectDtoModelType } from "./ProjectDtoModel"
import { ProjectDtoModelSelector } from "./ProjectDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  project: ProjectDtoModelType;
}

/**
 * ProjectDeletedDtoBase
 * auto generated base class for the model ProjectDeletedDtoModel.
 */
export const ProjectDeletedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectDeletedDto')
  .props({
    __typename: types.optional(types.literal("ProjectDeletedDto"), "ProjectDeletedDto"),
    /** Project that was just deleted */
    project: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => ProjectDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectDeletedDtoModelSelector extends QueryBuilder {
  project(builder: string | ProjectDtoModelSelector | ((selector: ProjectDtoModelSelector) => ProjectDtoModelSelector) | undefined) { return this.__child(`project`, ProjectDtoModelSelector, builder) }
}
export function selectFromProjectDeletedDto() {
  return new ProjectDeletedDtoModelSelector()
}

export const projectDeletedDtoModelPrimitives = selectFromProjectDeletedDto()
